import { useState } from "react";
import styles from "./ServiceUnavailable.module.css";
import own from "./OutsideWorkingHours.module.css";

/**
 * Shown when the backend says the student is outside their working hours (HTTP 423,
 * code "outside_working_hours"), at sign-in or when the app opens.
 *
 * @param {object} props
 * @param {{ message: string, zone: string, hours: {days: string, hours: string}[],
 *           opensAt: {dayLabel: string, label: string} | null }} props.notice  From the backend.
 */
export default function OutsideWorkingHours({ notice }) {
  const [checking, setChecking] = useState(false);
  const retry = () => {
    setChecking(true);
    // Sign-in and app start both re-check the hours, so a fresh load is the check.
    window.location.reload();
  };

  return (
    <div className={styles.overlay} role="alert" aria-live="polite">
      <div className={styles.art} aria-hidden>
        🌙
      </div>
      <h1 className={styles.title}>See you during learning time!</h1>
      <p className={styles.message}>{notice?.message}</p>

      {notice?.opensAt && (
        <div className={own.opens}>
          Read 21 opens{" "}
          <b>
            {(notice.opensAt.dayLabel ?? notice.opensAt.label.split(" at ")[0]).replace(
              /^(Today|Tomorrow|Next)/,
              (w) => w.toLowerCase(),
            )}
          </b>
        </div>
      )}

      {notice?.hours?.length > 0 && (
        <div className={own.card}>
          <div className={own.cardTitle}>Learning hours</div>
          {notice.hours.map((h) => (
            <div key={h.days} className={own.row}>
              <span className={own.days}>{h.days}</span>
              <span>{h.hours}</span>
            </div>
          ))}
        </div>
      )}

      <button type="button" className={styles.retry} onClick={retry} disabled={checking}>
        {checking ? "Checking…" : "Check again"}
      </button>
      <img src="/read21-logo.png" alt="Read21" className={styles.logo} />
    </div>
  );
}
